import type { CustomRoleTaxonomySelection } from '@revelio/data-access';
import { getAdaptiveRoleTaxonomyValue } from '@revelio/iso-utility';

import type { SelectionList } from '../../../../shared/selection-lists/types';
import type { TreeFilter } from '../types/filters';
import { extractRicsSelections } from '../utils/extractRicsSelections';

// Extracts the relevant selections from the company filter and delegates the
// heavy-lifting to `getAdaptiveRoleTaxonomyValue`. The adaptive role taxonomy is
// derived from this inside the reducer — see `deriveAdaptiveTaxonomies`.
export function getRoleTaxonomyValue(
  companyFilter: TreeFilter,
  ricsK400List: SelectionList<'rics_k400'>
): CustomRoleTaxonomySelection {
  const taxonomyId = getAdaptiveRoleTaxonomyValue({
    ricsK400List,
    ricsSelections: extractRicsSelections(companyFilter),
  });

  if (!taxonomyId || taxonomyId.includes('default')) {
    return { default: true };
  }
  if (taxonomyId.includes('rics_k10')) {
    const id = taxonomyId.split('custom_role_rics_k10_')[1];
    if (id === '0') return { default: true };
    return id ? { ricsK10Id: id } : { default: true };
  }
  if (taxonomyId.includes('rics_k50')) {
    const id = taxonomyId.split('custom_role_rics_k50_')[1];
    if (id === '0') return { default: true };
    return id ? { ricsK50Id: id } : { default: true };
  }
  return { default: true };
}
